<script>
export default {
  name: "BadgeDisplayMixin",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    showDates() {
      return ["challenge", "consistency", "event"].includes(this.type);
    },
    showVisible() {
      return ["challenge", "consistency", "event"].includes(this.type);
    },
    showEnabled() {
      return ["coach", "challenge", "consistency", "event"].includes(this.type);
    },
    showChallenge() {
      return ["challenge", "consistency", "event"].includes(this.type);
    },
    showQualifiers() {
      return ["challenge"].includes(this.type);
    },
    showWeeksQualifier() {
      return ["consistency"].includes(this.type);
    },
    showEvent() {
      return ["event"].includes(this.type);
    },
  },
};
</script>
